import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from 'rxjs';

@Component({
  selector: "app-message-box",
  templateUrl: "./message-box.component.html",
  styleUrls: ["./message-box.component.scss"]
})
export class MessageBoxComponent implements OnInit {
  @Input() public Content: any
  operation;
  action: Subject<any> = new Subject();
  constructor(
    public modalRef1:NgbActiveModal
  ) {
  }

  ngOnInit() {
     if(this.Content.heading=='' || this.Content.heading==null || this.Content.heading==undefined)
     {
      this.Content.heading="Validation Message(s)";
     }
  }

  showConfirm(getData): void {
    this.modalRef1.close('ok');
    //this.action.next('ok');
  }
  CancelClick(): void {
    this.modalRef1.close('cancel');
   // this.action.next('cancel');
  }
}
